import { useTranslation } from 'react-i18next';

import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import SelectedItems from 'components/desktop/_general/Input/TreeInput/SelectedItems';
import TreeComponent from 'components/desktop/_general/Input/TreeInput/TreeComponent';
import 'components/desktop/_general/Input/TreeInput/TreeInput.scss';
import useTreeInputState from 'components/desktop/_general/Input/TreeInput/useTreeInputState';
import * as Tree from 'types/_general/Tree/Tree';
import * as TreeList from 'types/_general/Tree/TreeList';

interface IProps {
	input: Tree.Type[];
	setSelected: (input: Tree.Type[]) => void;
	selected: Tree.Type[];
	disabled?: boolean;
	errorKey?: string;
	label: string;
	noObjectsFoundText?: string;
}

const TreeInput = (props: IProps) => {
	const { state, handlers } = useTreeInputState();
	const { t } = useTranslation();

	return (
		<>
			{props.label && <label>{props.label}</label>}
			<div error-key={props.errorKey} style={{ marginTop: '0px' }}>
				<RenderIf condition={!props.disabled}>
					<div
						className="input-group"
						style={{ display: 'flex', marginTop: '0px' }}
						tabIndex={1}
						onFocus={handlers.focus}
						onBlur={handlers.blur}
					>
						<input
							type="text"
							className="form-control"
							placeholder={t('_general:INPUT_PLACEHOLDER_SEARCHTERM')}
							onChange={(e) => handlers.setSearchTerm(e.target.value)}
						/>
						<div
							className="tree-input-box"
							style={{ display: state.showSuggested ? 'block' : 'none' }}
						>
							<TreeComponent
								input={props.input}
								setSelected={props.setSelected}
								selected={props.selected}
								searchTerm={state.searchTerm}
								noObjectsFoundText={props.noObjectsFoundText}
							/>
						</div>
					</div>
				</RenderIf>
				<SelectedItems
					all={props.input}
					selected={props.selected}
					removeFromSelected={(input: Tree.Type) => {
						props.setSelected(TreeList.removeItem(props.selected, input));
					}}
					readOnly={props.disabled}
				/>
			</div>
		</>
	);
};

export default TreeInput;
